import MuiFormLabel from '@mui/material/FormLabel';
import Tooltip from '../Tooltip';

export interface ITextFormInputProps {
  name: string;
  label: string;
  /** add a tooltip next to the form label */
  tooltipText?: string;
}

const FormLabel = ({ name, label, tooltipText }: ITextFormInputProps) => {
  return (
    <div className="bp-mb-2 bp-flex">
      <MuiFormLabel className="bp-font-primary-small bp-mr-3" htmlFor={`${name}-input`}>
        {label}
      </MuiFormLabel>
      {tooltipText && <Tooltip title={tooltipText} />}
    </div>
  );
};

export default FormLabel;
